import { flow, getEnv, Instance, types } from "mobx-state-tree";
import { endpoints } from "../api/ApiEndpoints";
import { FileStates, shopHistoryStorage } from "../shop/ShopHistoryStorage";
import { ActivityTypes } from "../shop/ActivityPricesStorage";
import { uploadFilesService } from "../upload/UploadFilesService";
import { api } from "../api/ApiService";
import { IServiceStorageEnv, ServiceModel } from "../app/ServiceStorage";
import { AppStorageModel } from "../app/AppStorage";

export const ConversionServiceModel = types.compose(
    types.model({
        sas: types.optional(types.string, ""),
        name: types.optional(types.string, "")
    }), ServiceModel
).extend(self => ({
    actions: {
        request: flow(function* () {
            const endpoint = endpoints.get("media_file_video_conversion");
            endpoint.routeParams = [self.fileId!];
    
            const response = yield getEnv<IServiceStorageEnv>(self).api.get(endpoint);
            self.sas = response.sas;
            self.isConverted = response.isConverted;
            self.status = self.getFileState(response.conversionWasSuccessful, response.conversionErrorMessage, !response.isConverted);
            self.name = response.name;
        }),
    
        runService: flow(function* () {
            const endpoint = endpoints.get("media_file_video_conversion");
            endpoint.routeParams = [self.fileId!];
    
            yield getEnv(self).api.put(endpoint);
        }),
    
        clear: () =>  {
            self.fileId = undefined;
            self.isConverted = false;
            self.sas = "";
            self.status = FileStates.Failed;
        },
    
        runAfterUpload: flow(function*() {
            yield shopHistoryStorage.load();
        })
    }
}))
.actions((self) => {
    return {
        copySas() {
            if (self.sas === "") return;
            navigator.clipboard.writeText(self.sas);
        }
    }
})

export type ConversionService = Instance<typeof ConversionServiceModel>;